import { FC } from 'react';
import cn from 'classnames';
import parse from 'html-react-parser';

import { IconName } from '@/shared/constants/icons';
import { iconInput } from '@/shared/inputs';
import { BuilderString } from '@/shared/types';
import { getBuilderString, getCleanInput, SanitizeMode } from '@/shared/text';

import styles from './List.module.scss';
import { ListItemLeading } from './ListItemLeading';

export const listInput = (name: string, friendlyName: string) => ({
  name,
  friendlyName,
  type: 'list',
  subFields: [
    {
      name: 'number',
      type: 'CatawikiEditor',
    },
    iconInput(),
    {
      name: 'content',
      type: 'CatawikiEditor',
    },
  ],
});

export interface ListItem {
  number: BuilderString;
  icon?: IconName;
  content: BuilderString;
}

interface Props {
  className?: string;
  items?: ListItem[];
  locale: string;
}

export const List: FC<Props> = ({ className, items, locale }) => {
  if (!items?.length) return null;
  return (
    <div className={cn(className, styles.list)}>
      {items.map((item, index) => {
        const number = getBuilderString(item.number, locale) || `${index + 1}`;
        const text = getBuilderString(item.content, locale) || 'List item';

        return (
          // eslint-disable-next-line react/no-array-index-key
          <p key={index} className={styles.item}>
            <ListItemLeading number={number} icon={item.icon} locale={locale} />
            <span className={cn('u-color-secondary')}>
              {parse(getCleanInput(locale, SanitizeMode.SINGLE_LINE, text))}
            </span>
          </p>
        );
      })}
    </div>
  );
};
